import Ajv from "ajv";
import addFormats from "ajv-formats";
import schema from "../schema/textEmbeddingVisualization.schema.json";

const ajv = new Ajv();
addFormats(ajv);
const validate = ajv.compile(schema);

/**
 * Validates the structure of a TEV visualization JSON object using JSON Schema.
 * @param {object} data
 * @returns {boolean}
 */
export function validateVisualizationData(data) {
  console.log("[validateVisualizationData] Validating data structure...", data);

  if (!data || typeof data !== "object") {
    console.error("[validateVisualizationData] Invalid data: not an object");
    return false;
  }

  // Schema already checks type/appName/etc, so no need to check again here

  const isValid = validate(data);
  if (!isValid) {
    console.error(
      "[validateVisualizationData] Data validation failed:",
      validate.errors
    );
    return false;
  }
  console.log("[validateVisualizationData] Data structure valid.");

  // Optionally: check schemaVersion/appVersion compatibility here

  return true;
}
